module.exports = __webpack_public_path__ + "img/07.ab3e1d6c.png";